.button {
  span {
    color: inherit;
  }
}
